import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const ChevronContainer = styled("div")`
    @media (min-width: ${breakpoints.values.md}px) {
        display: block;
    }
`

interface ChevronProps {
    $isOpen: boolean
    $isAtTop?: boolean
    $isStandard?: boolean
}

export const Chevron = styled("img", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<ChevronProps>`
    display: ${props => (props.$isAtTop || props.$isStandard ? "inline" : "none")};
    cursor: pointer;
    transform: ${props => (props.$isOpen ? "rotate(-180deg)" : "rotate(0deg)")};
    transition-duration: 500ms;
    margin-bottom: 0.00625rem;
    @media (min-width: ${breakpoints.values.md}px) {
        display: block;
    }
`
